import Navbar from '../home/components/Navbar';
import Hero from './components/Hero';
import Content from './components/Content';
import FAQ from './components/FAQ';
import Footer from '../home/components/Footer';
import { useSchemaOrg, usePageMeta } from '../../utils/seo';

export default function PianoMoversLondon() {
  // Set page meta tags
  usePageMeta(
    'Piano Movers London | 30,000+ Moves Since 2007 | 5-Star Rated',
    'London\'s most trusted piano movers. 30,000+ successful moves since 2007. All 32 boroughs, fully insured £5M, same-day available. Free quote — 020 3441 9463.',
    'piano movers London, piano moving service London, expert piano movers, piano moving company London',
    'https://www.pianomovers.co.uk/piano-movers-london',
    'Piano Movers London | 30,000+ Moves Since 2007',
    'London\'s most trusted piano movers. 30,000+ moves since 2007. All 32 boroughs, £5M insured, same-day available. Free quote — 020 3441 9463.',
    'Piano Movers London | 30,000+ Moves | 5-Star',
    'London\'s most trusted piano movers. 30,000+ moves since 2007. Fully insured £5M. Free quote — 020 3441 9463.'
  );

  // Add FAQ structured data
  useSchemaOrg({
    type: 'FAQPage',
    data: {
      mainEntity: [
        {
          '@type': 'Question',
          name: 'How many people does it take to move a piano in London?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'The number of people required to move a piano in London depends on the type and size of the instrument. A standard upright piano typically requires a minimum of two experienced piano movers, though three or four may be needed for larger uprights or challenging access situations involving stairs or narrow passages. Baby grand pianos usually require a team of three to four specialists due to their weight and the need for leg removal and reassembly. Concert grand pianos, which can weigh up to 600 kilograms, typically require four to five trained professionals to ensure safe handling throughout the move.',
          },
        },
        {
          '@type': 'Question',
          name: 'Can piano movers in London move a piano up stairs?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, professional piano movers in London are fully equipped and trained to move pianos up and down stairs safely. They use specialist equipment including piano boards with stair‑climbing capabilities, heavy‑duty straps, and protective padding to navigate staircases without damaging the instrument or property. For particularly challenging situations such as narrow Victorian staircases or multiple flights in apartment buildings, experienced piano movers may use additional techniques or equipment. In extreme cases where internal stairs are impossible, they can arrange external hoisting through windows using crane equipment.',
          },
        },
        {
          '@type': 'Question',
          name: 'How far in advance should I book piano movers in London?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'For optimal scheduling flexibility, it is recommended to book piano movers in London at least 2 to 3 weeks in advance, particularly if you require a weekend or end‑of‑month slot when demand is highest. However, many reputable piano moving companies can accommodate shorter notice periods, sometimes even same‑week bookings, depending on their current schedule. For complex moves requiring special equipment such as crane hoisting, or for moves during peak periods like summer months, booking 4 to 6 weeks ahead ensures you secure your preferred date.',
          },
        },
      ],
    },
  });

  return (
    <div className="bg-[#f5f5f0] text-[#1a1916]">
      <Navbar />
      <Hero />
      <Content />
      <FAQ />
      <div className="bg-[#1a1916] py-4 text-center">
        <p className="text-[#d4d4ce] text-xs">
          Piano Movers UK is an independent guide to piano removal services in London.
        </p>
      </div>
      <Footer />
    </div>
  );
}